module.exports = __webpack_public_path__ + "static/media/wrinkles_glabellar.1b92a881.svg";